import { Link } from "react-router-dom";
import styles from "./Articles.module.scss";

export const Article6 = () => {
  return (
    <div className={styles.articles__wrapper}>
      <Link to={"/articles"}>&#8592; Назад к статьям</Link>
      <h5 className={styles.articles__header}>
        Что дает трансформационная игра? И что из себя представляет?
      </h5>
      <p className={styles.articles__pharagraph}>
        Трансформационная игра – это инновационная игровая методика в психологии
        для самоисследования и проработки интересующих каждого вопросов.{" "}
        <b>Что дает трансформационная игра?</b> Такие игры помогают людям
        меняться, трансформироваться для достижения своих целей, желаний.
        Игровой подход в психологии далеко не новая практика, однако показывает
        до сих пор отличные результаты, ведь атмосфера игры и азарта
        способствует наиболее благоприятному и спокойному обдумыванию и приходу
        к необходимому решению.
      </p>
      <p className={styles.articles__pharagraph}>
        Наша платформа предоставляет возможность участвовать в таких{" "}
        <b>топовых трансформационных играх</b> в комфортном формате с
        возможностями активного взаимодействия с метафорическими ассоциативными
        картами (МАК), таким образом:
        <ul>
          <li>
            Совершать с ними различные манипуляции на рабочем столе в разных
            вариациях;
          </li>
          <li>Упорядочивать в нужной комбинации;</li>
          <li>Изменять их параметры и поворачивать;</li>
        </ul>
      </p>
      <p className={styles.articles__pharagraph}>
        <b>В чем преимущества нашей топ-платформы для трансформационных игр?</b>
        <ul>
          <li>Эргономичность и удобство в использовании;</li>
          <li>Наличие готовых для вас инструкций и обучающих материалов;</li>
          <li>Обратная связь с разработчиками в прямом доступе;</li>
          <li>Индивидуальный подход к каждому клиенту;</li>
          <li>Работа не только готовыми МАК, но и создание своих вариантов;</li>
          <li>Удобная оплата онлайн без комиссий;</li>
          <li>Оперативная обработка заказов;</li>
          <li>Возможность участия каждого в развитие программы;</li>
          <li>Партнерские программы;</li>
          <li>Приятные скидки для постоянных клиентов;</li>
          <li>
            Регулярная работа над исправлением ошибок и над обновлением для
            вашего удобства;
          </li>
          <li>Технические решения от лучших IT-компаний.</li>
        </ul>
      </p>
      <p className={styles.articles__pharagraph}>
        <b>
          Для стабильной работы нашей платформы и проведения трансформационных
          игр необходимо учесть следующие требования системы:
        </b>
        <ul>
          <li>
            Процессор: Intel Pentium IV или AMD Athlon 64 с частотой 3.0 ггц.;
          </li>
          <li>Память оперативной системы: около 1 гб.;</li>
          <li>Свободное пространство диска: 300 мб.;</li>
          <li>
            Наличие мыши, клавиатуры, гарнитуры или наушников с микрофоном;
          </li>
          <li>Операционная система: версии Windjws, МacOS, Linux;</li>
          <li>Доступ в интернет.</li>
        </ul>
      </p>
      <p className={styles.articles__pharagraph}>
        Наша платформа активно ведет работу и дает возможности для проведения не
        только трансформационных игра, но и для консультаций, коучинговых
        сессий, гаданий по таро, и просто для работы с клиентами. Сотни
        довольных клиентов и положительных отзывов показатель нашей отличной
        работы. Если вы тоже предпочитаете удобство в дистанционной работе, то
        мы вам поможем и предлагаем ознакомиться с{" "}
        <b>ценами трансформационных игр</b>и пакетов нашей платформы для
        консультаций в каталоге.
      </p>
      <p className={styles.articles__pharagraph}>
        В случае каких- то сложностей, вы можете легко с нами связаться, и мы
        вам с радостью поможем разобраться с вашей проблемой.
      </p>
    </div>
  );
};
